import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const BoxStyled = styled(Box)(() => ({
  alignItems: 'center',
  display: 'inline-flex',
  position: 'relative',
}));
